export default __webpack_public_path__ + "static/media/us3.06be8ac1.jpeg";